









































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'GestionFeedDownloads',  
})
export default class GestionFeedDownloads extends Vue {
  private loading = false
  private showError = false 
  
  private toolbarHeight = 50

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - this.toolbarHeight - 25
  }

  onResize(){
    //@ts-ignore
    this.toolbarHeight = this.$refs.toolbar.$el.clientHeight
  }
  

  private get feedDownloadsList() {
    return this.$store.myGetters.feedDownloadsList
  }
  
  private get search(){
    return this.$store.myGetters.searchFeedDownload
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_FEEDDOWNLOAD(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortFeedDownloadDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_FEEDDOWNLOAD_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortFeedDownloadBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_FEEDDOWNLOAD_BY(value)
  }

  private get headers(){
    return [
      { text: 'ID', value: 'id', width:80 },            
      { text: 'FeedDownload', value: 'libelle' }
    ]
  } 

  created() {
    this.loading = true
    this.$store.myActions.ADM_FEEDDOWNLOAD_ENSURE().finally(() => {
      this.loading = false
    })
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyFeedDownloads',params:{dldId:item.id}})
  } 
 
  addFeedDownload(){
    //@ts-ignore
    this.$router.push({name:'ModifyFeedDownloads',params:{dldId:0}})
  } 
 
}
